export class PolylineItem {
    public sphere;
    public link;
    public polyline;

    constructor(sphere, link, polyline) {
        this.sphere = sphere;
        this.link = link;
        this.polyline = polyline;
    }
}